import { METHOD } from 'services/method'

export const API_BEST_SELLER = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/best-seller',
        method: METHOD.GET,
    },
    URL_IMAGE_BACKGROUND: {
        api: '/v1/dashboard-admin/main-page/home-page/best-seller/storage-url/attachment',
        method: METHOD.POST,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/main-page/home-page/best-seller/product',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/best-seller',
        method: METHOD.PUT,
    },
}
